var map = {
	"./add_image.svg": "922d",
	"./age.svg": "04ae",
	"./arrow.svg": "21e2",
	"./arrow_left.svg": "93ae",
	"./arrow_right.svg": "e45f",
	"./arrow_solid_right.svg": "b816",
	"./attention.svg": "d178",
	"./calendar.svg": "b8bd",
	"./cart.svg": "daca",
	"./chart.svg": "2f02",
	"./chat.svg": "9b69",
	"./checkbox.svg": "5b02",
	"./clipboard.svg": "4247",
	"./clock.svg": "755b",
	"./cloud_done.svg": "348b",
	"./cloud_error.svg": "5ad0",
	"./cloud_pending.svg": "1bc7",
	"./cloud_retry.svg": "728e",
	"./cloud_saved.svg": "2aaf",
	"./cloud_saving.svg": "a579",
	"./connections.svg": "7865",
	"./cross.svg": "2ad7",
	"./dashboard.svg": "ecef",
	"./dashboard_alternate.svg": "e22f",
	"./description.svg": "e991",
	"./drag_handle.svg": "4cec",
	"./end_chapter.svg": "2943",
	"./feedback.svg": "eaaf",
	"./in_draft.svg": "5575",
	"./info_icon.svg": "16fe",
	"./location.svg": "d2eb",
	"./map_pin.svg": "756b",
	"./menu.svg": "d17f",
	"./page.svg": "741b",
	"./pending_review.svg": "c088",
	"./people.svg": "1a5b",
	"./person.svg": "d104",
	"./publishing.svg": "47d7",
	"./qr_code.svg": "6dc4",
	"./question_mark.svg": "1864",
	"./remove.svg": "5088",
	"./server_warning_icon.svg": "e2ee",
	"./settings.svg": "9174",
	"./star.svg": "cc90",
	"./tabler_template.svg": "454d",
	"./tags.svg": "6ba8",
	"./tale.svg": "be56",
	"./time.svg": "79aa",
	"./treasure_chest.svg": "c5cd",
	"./ufo.svg": "8d48",
	"./upload.svg": "5a96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";